import React, {PropTypes} from "react";
import {connect} from 'react-redux';

class FeedbackRadio extends React.Component {
	render() {
		const {label,id,required,answerList} = this.props;

		const answerItems = answerList.map((answer) =>
			  <div className="inlineBlock"> 
                    <input type="radio" data-answerId={answer.id} data-questionId={id} value={answer.value} name="feedback-radio" id={answer.id} />
                    <label htmlFor={answer.id}><span>{answer.value}</span></label>
             </div>
			);
			
			return ( 
				<div>
				        <h4>{label}</h4>
                            <div className="feedback-score">
                              {answerItems}
                            </div>
                        </div>
				);
	}
}
export default FeedbackRadio;


/** WEBPACK FOOTER **
 ** ./src/feature/feedback/feedbackRadio.js
 **/